import script from "./prescription.vue?vue&type=script&setup=true&lang=js"
export * from "./prescription.vue?vue&type=script&setup=true&lang=js"

import "./prescription.vue?vue&type=style&index=0&id=e0cd102a&lang=scss&scoped=true"

import exportComponent from "/root/workspace/Astig_Counter_tFv5/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e0cd102a"]])

export default __exports__